import { useState } from "react";
import axiosInstance from "../utils/axiosInstance"; // Import your axios instance
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const notify = (msg, type) => {
    toast[type](msg);
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (!email) {
      notify("Please enter your email", "error");
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.post("/auth/forgot-password", {
        email,
      });

      if (response.status === 200) {
        notify("Password reset OTP sent to your email!", "success");
        setOtpSent(true); // Show OTP form after successful OTP send
      } else {
        notify("Failed to send reset OTP. Please try again.", "error");
      }
    } catch (error) {
      notify(
        error.response?.data?.message ||
          "Something went wrong. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!otp || !newPassword) {
      notify("Please fill in all fields", "error");
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.post("/auth/reset-password", {
        email,
        otp,
        newPassword,
      });

      if (response.status === 200) {
        notify("Password reset successful!", "success");
        setTimeout(() => navigate("/auth/login/buyer"), 3000);
      } else {
        notify("Failed to reset password. Please try again.", "error");
      }
    } catch (error) {
      notify(
        error.response?.data?.message ||
          "Something went wrong. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-md shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center text-green-600">
          Forgot Password
        </h2>
        {!otpSent ? (
          <form onSubmit={handlePasswordReset} className="space-y-4">
            <div>
              <label htmlFor="email" className="block mb-2">
                Enter your email:
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
                placeholder="you@example.com"
              />
            </div>

            <button
              type="submit"
              className={`w-full py-2 px-4 bg-green-600 text-white font-bold rounded-md ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Reset OTP"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleResetPassword} className="space-y-4">
            <div>
              <label htmlFor="email" className="block mb-2">
                Email:
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                readOnly
                className="w-full p-2 border border-gray-300 rounded-md bg-gray-100"
                placeholder="you@example.com"
              />
            </div>

            <div>
              <label htmlFor="otp" className="block mb-2">
                Enter OTP:
              </label>
              <input
                type="text"
                id="otp"
                name="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
                className="w-full p-2 border border-gray-300 rounded-md"
                placeholder="Enter OTP"
              />
            </div>

            <div>
              <label htmlFor="newPassword" className="block mb-2">
                New Password:
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="newPassword"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  className="w-full p-2 border border-gray-300 rounded-md"
                  placeholder="Enter new password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500"
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className={`w-full py-2 px-4 bg-green-600 text-white font-bold rounded-md ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loading}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        )}

        <p className="text-center mt-4">
          Remember your password?{" "}
          <span
            className="text-blue-500 cursor-pointer hover:underline"
            onClick={() => navigate("/auth/login/buyer")}
          >
            Login
          </span>
        </p>
      </div>

      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;
